import * as dataAccess from 'app/utils/ajax';
import { API_CONSTANTS } from 'app/constants/api-contants';
import { fetchData } from './comonsearch';

export const getBillList = async (param) => {
  const baseUrl = `${API_CONSTANTS.BILL}/list`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};

// Starts an async excel export of the filtered bill list; responds with a
// jobId to poll. fetchData drops ''/null params, matching how the listing
// call skips empty filters.
export const exportBills = async (param) => {
  const baseUrl = `${API_CONSTANTS.BILL}/export`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};

// Bill-scoped export status poll. Deliberately NOT the shared
// /admin/export/status route: that path maps to the Analytics_and_Reporting
// permission module, which 401s (and force-logs-out) admins holding only
// Bill_Validation.
export const getBillExportStatus = async (jobId) => {
  return await dataAccess.get(`${API_CONSTANTS.BILL}/export-status/${jobId}`);
};

export const addBill = async (incomingData) => {
  let payload = {
    data: {
      ...incomingData,
    },
  };

  let response = await dataAccess.post(`${API_CONSTANTS.BILL}/upload`, payload);
  return response;
};
export const approveBill = async (id, type, incomingData) => {
  let url = '';
  url = `${API_CONSTANTS.BILL}/update?billId=${id}&type=${type}`;

  let payload = {
    data: {
      ...incomingData,
    },
  };
  let response = await dataAccess.put(url, payload);
  return response;
};

export const getBillById = async (id) => {
  let url = `${API_CONSTANTS.BILL}/detail?billDetailId=${id}`;

  let responseObj = await dataAccess.get(url);
  return responseObj;
};

export const deleteBill = async (id) => {
  let url = `${API_CONSTANTS.BILL}/delete?billDetailId=${id}`;
  let payload = {
    data: {
      id: id,
    },
  };
  let responseObj = await dataAccess.del(url, payload);
  return responseObj;
};
export async function uplaodMedia(file) {
  let formData = new FormData();
  formData.append('image', file);
  let payload = {
    data: formData,
  };

  let responseObj = await dataAccess.upload(
    `${API_CONSTANTS.MEDIA_UPLOAD}`,
    payload
  );

  return responseObj;
}

export const getBillRejectReasonList = async (param) => {
  const baseUrl = `${API_CONSTANTS.BILL}/bill-reject-reasons`;
  let responseObj = await dataAccess.get(baseUrl);
  return responseObj;
};


export async function uplaodBillMedia(file) {
  let formData = new FormData();
  formData.append('image', file);
  let payload = {
    data: formData,
  };

  let responseObj = await dataAccess.upload(
    `${API_CONSTANTS.MEDIA_BILL_UPLOAD}`,
    payload
  );

  return responseObj;
}